import { Alert } from "@mui/material";
import { useState, type FC } from "react";
import { useCachedAssets } from "../../../../assets/hooks/use-cached-assets";
import { ContentLibraryEmptyModal } from "./content-library/content-library-empty-modal";
import { ContentLibraryLoadingModal } from "./content-library/content-library-loading-modal";
import { ContentLibraryModal } from "./content-library/content-library-modal";

export const FromContentLibraryModal: FC<{
  open: boolean;
  onClose: () => void;
}> = ({ open, onClose }) => {
  const { data, error, reload, loading } = useCachedAssets();
  const [lastUploadFolderId, setLastUploadFolderId] = useState<string | null>(null);

  if (error)
    return (
      <Alert severity="error">
        Sorry, there was a problem retrieving your content. Please try again later
      </Alert>
    );

  if (loading) return <ContentLibraryLoadingModal open={open} onClose={onClose} />;

  return data && data.length > 0 ? (
    <ContentLibraryModal
      open={open}
      onClose={onClose}
      assets={data}
      initialFolderId={lastUploadFolderId}
      onAssetUploaded={(folderId) => {
        if (folderId) setLastUploadFolderId(folderId);
        reload();
      }}
    />
  ) : (
    <ContentLibraryEmptyModal open={open} onClose={onClose} />
  );
};
